import type Context from '@/context';
import type { IProjectModel } from '@/interfaces/models';
import { ProjectModel } from '@/models/ProjectModel';

export class ProjectModelFactory {
  create(context: Context, name: string): IProjectModel {
    return new ProjectModel(context, name);
  }
}
